import { createAction, props } from '@ngrx/store';

import { DriversGroupItem, DriversGroupsList } from '../../app/portal/pages/drivers/drivers.types';

export const loadDriversGroups = createAction('[Drivers Groups] Load Drivers Groups');

export const loadDriversGroupsSuccess = createAction(
  '[Drivers Groups] Load Drivers Groups Success',
  props<{ list: DriversGroupsList }>(),
);

export const loadDriversGroupsFailure = createAction(
  '[Drivers Groups] Load Drivers Groups Failure',
  props<{ error: string }>(),
);

export const addDriversGroup = createAction(
  '[Drivers Groups] Add Drivers Group',
  props<{ driversGroup: DriversGroupItem }>(),
);
export const updateDriversGroup = createAction(
  '[Drivers Groups] Update Drivers Group',
  props<{ id: number; changes: Partial<DriversGroupItem> }>(),
);
export const deleteDriversGroup = createAction(
  '[Drivers Groups] Delete Drivers Group',
  props<{ id: string }>(),
);
